import React, { useState } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import './candidateContactSection.css';
import myImage from '../../../../assets/images/rocket.png';
import { ClientPreLoginService } from '../../../../services/clientPreLoginService';
const CandidateContactSection = () => {
    const [message, setMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState(sessionStorage.getItem('errorMessage') || '');

    const [formData, setFormData] = useState({
        name: "",
        emailId: "",
        mobileNo: "",
        message: "",
    });

    const [errors, setErrors] = useState({});
    const maxCharacters = 150;

    // Validation Patterns
    const namePattern = /^[A-Za-z\s]+$/;
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const mobilePattern = /^\+?[0-9]{1,3}[0-9]{10}$/;

    const validateField = (name, value) => {
        let error = "";
        if (name === "name") {
            if (!value.trim()) {
                error = "Name is required";
            } else if (!namePattern.test(value)) {
                error = "Name must contain only letters";
            }
        } else if (name === "email") {
            if (!value.trim()) {
                error = "Email is required";
            } else if (!emailPattern.test(value)) {
                error = "Enter a valid email address";
            }
        }
        else if (name === "mobileNo") {
            if (!value.trim()) {
                error = "Mobile Number is required";
            } else if (!mobilePattern.test(value)) {
                error = `Enter a valid phone number (+918760XXXXX6)`;
            }
        }
        else if (name === "message") {
            if (value.length >= maxCharacters) {
                error = `Character limit reached! (Max: ${maxCharacters})`;
            }
        }
        return error;
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        if (name === "message" && value.length > maxCharacters) return;

        const newValue = name === "mobileNo" ? value.replace(/^0+/, '') : value;
        setFormData({ ...formData, [name]: newValue });
        setErrors({ ...errors, [name]: validateField(name, newValue) });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const newErrors = {};
        Object.keys(formData).forEach((key) => {
            newErrors[key] = validateField(key, formData[key]);
        });

        setErrors(newErrors);

        if (Object.values(newErrors).every((error) => error === "")) {
            const requestBody = {
                name: formData.name,
                emailId: formData.emailId,
                mobileNo: formData.mobileNo,
                message: formData.message,
            };

            try {
                const response = await ClientPreLoginService.letsTalkContactForm(requestBody);
                if (response.status === 200) {
                    setErrorMessage("Form submitted successfully!");
                    setFormData({
                        name: "",
                        emailId: "",
                        mobileNo: "",
                        message: "",
                    });
                    setErrors({});
                } else {
                    console.error("Failed response:", response);
                    setErrorMessage("Failed to submit.");
                }
            } catch (error) {
                console.error("Contact request failed:", error);
                setErrorMessage("Failed to submit");
            }
        }
    };

    return (
        <Container>
            {errorMessage && (
                <div className="login-alert-overlay">
                    <div className="login-alert-box">
                        <div className="login-alert-content">
                            <p>{errorMessage}</p>
                            <button className="login-alert-button" onClick={() => setErrorMessage('')}>
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <Row className="align-items-center candidate-contact-container">
                <Col md={6} xl={6} className="left-content">
                    <div className="contact-content">
                        <h4>LET'S TALK!</h4>
                        <p><i className="fas fa-envelope"></i> sales@leaderly.in</p>
                        <p><i className="fas fa-phone-alt"></i> +91 7738333452</p>
                        <p><i className="fas fa-map-marker-alt"></i> Delhi, Mumbai, Bangalore</p>
                    </div>
                    <div className="image">
                        <img src={myImage} alt="Rocket" className="rocket-image" />
                    </div>
                </Col>

                <Col md={6} xl={6} className="input-container">
                    <Form>
                        <Form.Group controlId="formName" className="input-group">
                            <Form.Control
                                type="text"
                                className={`input-field ${errors.name ? "input-error" : ""}`}
                                name="name"
                                value={formData.name}
                                onChange={handleInputChange}
                                spellCheck="false"
                            />
                            <span className="input-underline"></span>
                            <label className="input-label">Name *</label>
                            {errors.name && <span className="error-text">{errors.name}</span>}
                        </Form.Group>

                        <Form.Group controlId="formEmail" className="input-group">
                            <Form.Control
                                type="emailId"
                                className={`input-field ${errors.emailId ? "input-error" : ""}`}
                                name="emailId"
                                value={formData.emailId}
                                onChange={handleInputChange}
                                spellCheck="false"
                            />
                            <span className="input-underline"></span>
                            <label className="input-label">Email ID *</label>
                            {errors.emailId && <span className="error-text">{errors.emailId}</span>}
                        </Form.Group>
                        <Form.Group controlId="formMobile" className="input-group">
                            <Form.Control
                                type="mobileNo"
                                className={`input-field ${errors.mobileNo ? "input-error" : ""}`}
                                name="mobileNo"
                                value={formData.mobileNo}
                                onChange={handleInputChange}
                                spellCheck="false"
                            />
                            <span className="input-underline"></span>
                            <label className="input-label">Mobile Number *</label>
                            {errors.mobileNo && <span className="error-text">{errors.mobileNo}</span>}
                        </Form.Group>
                        <Form.Group controlId="formMessage" className="input-group">
                            <Form.Control
                                as="textarea"
                                className={`input-field message-field ${errors.message ? "input-error" : ""}`}
                                rows={3}
                                name="message"
                                value={formData.message}
                                onChange={handleInputChange}
                            />
                            <span className="input-underline"></span>
                            <label className="input-label">Message (Optional)</label>
                            {errors.message && <span className="error-text">{errors.message}</span>}
                        </Form.Group>

                        {/* {message.length === maxCharacters && (
              <div className="message-limit-exceeded" style={{ color: "red", fontSize: "14px", marginTop: "5px" }}>
                Character limit exceeded! (Max: {maxCharacters})
              </div>
            )} */}

                        <button type="submit" className="submit-button" onClick={handleSubmit}>
                            Submit
                        </button>
                    </Form>
                </Col>
            </Row>
            <style>
                {`
          .error-text {
            color: red;
            font-size: 12px;
            margin-top: 5px;
            display: block;
          }
          .input-error {
            border-color: red;
          }
        `}
            </style>
        </Container>
    );
};

export default CandidateContactSection;
